import { queryPremiumRateForHic as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForHIC as calculateRiderPremium } from 'core/service/rider/premium-calculation'

export default {
  calculateRiderPremium,
  queryPremiumRate,
}
